import React, { useState, Fragment, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useScreen from 'hooks/useScreen';
import { isEmpty, find, propEq } from 'ramda';
import Seo from 'sharedComponents/Seo';

import useStates from 'reducers/hooks/useStates';
import useOfferings from 'reducers/hooks/useOfferings';

import DesktopNavTabs from './components/DesktopNavTabs';
import MobileNavTabs from './components/MobileNavTabs';
import ResetPassword from './components/ResetPassword';
import Profile from './components/Profile';
import LicensedStates from './components/LicensedStates';
import SubscriptionPage from './components/SubscriptionPage';
import AutoFollowupsMessages from './components/AutoFollowupsMessages';

import useStyles from './useStyles';

const LoanOfficerSettings = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isDesktop } = useScreen();
  const { states, loadStates, loading: statesLoading } = useStates();
  const { offerings, loadOfferings, loading: offeringsLoading } = useOfferings();

  useEffect(() => {
    if (isEmpty(states)) {
      const params = 'all';
      loadStates(params);
    }
    if (isEmpty(offerings)) {
      loadOfferings();
    }
  }, []);

  const startScreenValue = 0;
  const initialValue = isDesktop ? 1 : startScreenValue;
  const [activeTabIndex, setActiveTabIndex] = useState(initialValue);

  const handleChangeActiveTabDesktop = (_event, newValue) => {
    setActiveTabIndex(newValue);
  };
  const handleChangeActiveTabMobile = newValue => {
    setActiveTabIndex(newValue);
  };

  const tabList = [
    {
      id: 1,
      label: t('components.LoanOfficerSettings.navTabs.subscriptions'),
      content: <SubscriptionPage onBack={handleChangeActiveTabMobile} />,
    },
    {
      id: 2,
      label: t('components.LoanOfficerSettings.navTabs.profile'),
      content: (
        <Profile onBack={handleChangeActiveTabMobile} offerings={offerings} isLoadingOfferings={offeringsLoading} />
      ),
    },
    {
      id: 3,
      label: t('components.LoanOfficerSettings.navTabs.licensedStates'),
      content: <LicensedStates onBack={handleChangeActiveTabMobile} states={states} isLoadingStates={statesLoading} />,
    },
    {
      id: 4,
      label: t('components.LoanOfficerSettings.navTabs.resetPassword'),
      content: <ResetPassword onBack={handleChangeActiveTabMobile} />,
    },
    {
      id: 5,
      label: t('components.LoanOfficerSettings.navTabs.autoFollowupsMessages'),
      content: <AutoFollowupsMessages onBack={handleChangeActiveTabMobile} />,
    },
  ];

  const activeTab = find(propEq('id', activeTabIndex))(tabList);

  const renderMobileContent = () => {
    if (activeTabIndex === startScreenValue)
      return <MobileNavTabs handleChangeActiveTab={handleChangeActiveTabMobile} list={tabList} />;

    return activeTab.content;
  };

  const renderDesktopContent = () => {
    return (
      <Fragment>
        <Seo title={t('meta.LoanOfficerSettings.title')} description={t('meta.LoanOfficerSettings.description')} />
        <DesktopNavTabs
          activeTab={activeTabIndex}
          handleChangeActiveTab={handleChangeActiveTabDesktop}
          list={tabList}
        />
        {activeTab.content}
      </Fragment>
    );
  };

  return (
    <div className={classes.container}>
      <Seo title={t('meta.LoanOfficerSettings.title')} description={t('meta.LoanOfficerSettings.description')} />
      <Typography variant="h2" className={classes.header}>
        {t('components.LoanOfficerSettings.header')}
      </Typography>
      <div className={classes.content}>{isDesktop ? renderDesktopContent() : renderMobileContent()}</div>
    </div>
  );
};

export default LoanOfficerSettings;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/LoanOfficerSettings.js